export default __webpack_public_path__ + "static/media/cesto_asparagi.9668185a.svg";